<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Kategorie dokumentów elektronicznych</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja kategorii</template>
          <template v-else>Dodawanie kategorii</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/kategorie-dokumentow-elektronicznych')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer ref="services-form" tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'edocuments-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.eDocumentsCategory;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        name: '',
        category_id: '',
        description: '',
        filename: '',
        id: ''
      },
      eDocumentsCategory: [],
      loaded: false,
      loadError: false,
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/edocuments/category/item/',
        instanceFields: ['name', 'category_id', 'description', 'filename', 'id'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/edocuments/category/items',
        params: {
          pagination: false
        },
        outputKey: 'eDocumentsCategory',
        loadedKey: 'loadedCategories',
        errorKey: 'loadError',
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['services-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/edocuments/category/update/' + this.id : '/edocuments/category/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano dokument',
        successText: 'Wybrany dokument elektroniczny został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje dokumentu elektronicznego nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/kategorie-dokumentow-elektronicznych')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        category_id: this.data.category_id,
        description: this.data.description,
        filename: this.data.filename,
        id: this.data.id
      };
    }
  }
};
</script>
